import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ResolverService } from 'src/app/core';
import { Profile } from 'src/app/core/models/initials.model';
import { CustomersFacadeService } from 'src/app/modules/customers/services/customers-facade.service';
import { SnackBarService } from 'src/app/shared';
import { environment } from 'src/environments/environment';
import { PostpaidService } from '../../services/postpaid.service';

@Pipe({ name: "zeroPadding" })
export class zeroPaddingPipe implements PipeTransform {
  constructor() { }
  transform(value) {
    return String(value).padStart(6, '0');
  }
}
@Component({
  selector: 'app-invoice-detail',
  templateUrl: './invoice-detail.component.html',
  styleUrls: ['./invoice-detail.component.scss']
})
export class InvoiceDetailComponent implements OnInit {

  isSelfInvoice: boolean = false;
  invoiceDetails: any;
  invoiceItems: any;
  titles: string[] = ['No', /*'Company',*/ 'PRODUCT', 'QUANTITY', 'UNIT PRICE', 'TOTAL PRICE']
  topLevelUser: Profile;
  invoiceUserData: Profile;
  isAdmin: boolean = false;
  showInvoiceHeader: boolean = true;
  piNumber: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private customerService: CustomersFacadeService,
    private snackbarService: SnackBarService,
    private resolvedService: ResolverService,
    private titleService: Title,
    private postpaidService: PostpaidService
  ) { }

  ngOnInit(): void {
    this.getUrlData();
    // if (this.resolvedService.userInitInfo.profile.role.role_id == environment.role_types.admin) {
    //   this.piNumber = window.prompt('Enter PI Number(Optional)')
    // }
  }

  getUrlData() {
    this.activatedRoute.params.subscribe(
      params => {
        const id = params.id;
        this.activatedRoute.queryParams.subscribe(
          query => {
            if (query.self == '1') this.isSelfInvoice = true;
            this.showInvoiceHeader = !this.isSelfInvoice;
            this.getInvoiceDetails(id);
            this.setupHeaderData();
          }
        )
      }
    )
  }


  setupHeaderData() {
    this.topLevelUser = { ...this.resolvedService.userInitInfo.profile };
    this.isAdmin = this.topLevelUser.role.role_id == environment.role_types.admin;
    if (this.isAdmin) {
      this.showInvoiceHeader = true;
    }
    if (this.isAdmin) {
      this.showInvoiceHeader = true;
      this.topLevelUser.company = environment.title;
      // this.topLevelUser.address = `7940 Silverton Ave. Suite 101-A
      //         San Diego, CA 92126`;
      this.topLevelUser.company_logo = environment.logoPrintSrc;
      this.topLevelUser.email = environment.email;
      this.topLevelUser.phone = environment.webUrl;
    } else if (this.isSelfInvoice) {
      if (!this.topLevelUser.reseller) {
        this.showInvoiceHeader = true;
        this.topLevelUser.company = environment.title;
        this.topLevelUser.address = `7940 Silverton Ave. Suite 101-A
                San Diego, CA 92126`;
        this.topLevelUser.company_logo = environment.logoPrintSrc;
        this.topLevelUser.email = environment.email;
        this.topLevelUser.phone = environment.webUrl;
      } else {
        this.showInvoiceHeader = true;
        this.topLevelUser = { ...this.resolvedService.userInitInfo.profile.reseller }
      }
    }
  }

  // getInvoiceUserData(id) {

  //   this.customerService.getUserProfileById(id).subscribe(
  //     data => {
  //       this.invoiceUserData = data;
  //     }
  //   )
  // }

  getInvoiceDetails(id: number) {
    // const filter = {
    //   type: this.isSelfInvoice ? 1 : 2
    // };

    this.postpaidService.getInvoiceDetail(id).subscribe(
      details => {
        this.invoiceDetails = details;
        window.onbeforeprint = function () {
          var table: any = document.getElementById('invoice-table');
          if (table) {
            if (table.rows.length == 10) {
              table.rows[9].classList.add('page-break');
            }
            if (table.rows.length > 9) {    
              console.log('here')          
              var rows = table.rows;
                rows[9].classList.add('page-break');
                let i=9;
                while(i < table.rows.length){
                  if(rows[16+i]){
                    rows[16 + i].classList.add('page-break');
                  }
                  i = i + 16
                }
            }
          }
        };
        this.titleService.setTitle(`Invoice #${details?.id}`)
        if (!this.isSelfInvoice) {
          // this.getInvoiceUserData(details.user.profile_id);
          this.invoiceUserData = details.company
        } else {
          this.invoiceUserData = this.resolvedService.userInitInfo.profile;
        }
      },
      error => {
        this.snackbarService.showSnack(error.detail);
      }
    )
  }

  // getInvoiceItems(id: number) {
  //   const filter = {
  //     type: this.isSelfInvoice ? 1 : 2
  //   };

  //   this.customerService.getCascadeSellInvoiceItems(id, filter).subscribe(
  //     items => {
  //       this.invoiceItems = items;
  //     },
  //     error => {
  //       this.snackbarService.showSnack(error.detail);
  //     }
  //   )
  // }

  getLocalTimezone() {
    return this.resolvedService.userInitInfo.profile.timezone_data ? this.resolvedService.userInitInfo.profile.timezone_data.code : 'UTC';
  }

  printInvoice() {
    window.print();
  }

  calcTotal() {
    if (this.invoiceDetails?.items) {
      return this.invoiceDetails?.items.reduce((sum, current) => sum + (current.count * current.unit_price), 0)
    }
  }

  calcRemainingBalance() {
    return this.invoiceDetails.remaining_balance - this.invoiceDetails.credits;
  }

}
